// Checkbox.jsx
import React from "react";
import { Check } from "lucide-react";

export default function Checkbox({
  checked,
  onChange,
  label,
  description,
  icon: Icon,
  className = "",
  ...props
}) {
  const ACCENT = "#169FA7";

  return (
    <label className={`flex gap-3 ${className}`}>
      <span className="relative inline-grid place-items-center mt-0.5">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className="peer absolute h-0 w-0 opacity-0"
          {...props}
        />
        <span
          className={[
            "h-5 w-5 rounded-md border",
            "border-neutral-300 dark:border-neutral-700",
            "bg-white dark:bg-neutral-900",
            "shadow-sm",
            "peer-focus-visible:outline-none peer-focus-visible:ring-1",
          ].join(" ")}
          style={{ boxShadow: "inset 0 0 0 0px var(--ring)", "--ring": ACCENT }}
        />
        <Check className="pointer-events-none absolute h-4 w-4 z-20 text-white opacity-0 peer-checked:opacity-100 transition" />
        <span
          className="pointer-events-none absolute h-5 w-5 rounded-md opacity-0 peer-checked:opacity-100"
          style={{ background: ACCENT }}
        />
      </span>

      <span className="text-start">
        <span className="flex items-center gap-2 text-sm font-medium text-neutral-800 dark:text-neutral-200">
          {Icon && <Icon size={16} className="text-neutral-500" />}
          {label}
        </span>
        {description && (
          <span className="block text-xs text-neutral-500 dark:text-neutral-400">
            {description}
          </span>
        )}
      </span>
    </label>
  );
}
